import React, { useState, useMemo, useContext } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Theme } from '@mui/material'
import "../css/receivefunds.css"
import { Scrollbars } from 'react-custom-scrollbars'
import {FirebaseContext} from "../../../context/firebase";


const useStyles = makeStyles((theme: Theme) => ({
  // your styles unchanged...
}))

interface Props {
  handleBeneficiaryClose: () => void
  setTransferActiveBeneficiary: React.Dispatch<React.SetStateAction<string>>
  checkAccountNumber: () => void
}

const BeneficiariesPopup: React.FC<Props> = ({
  handleBeneficiaryClose,
  setTransferActiveBeneficiary,
  checkAccountNumber
}) => {
  const { data, error, refresh } = useContext(FirebaseContext);

  const classes = useStyles()
  const [search, setSearch] = useState('')

  const selectBeneficiaryHandle = (ben: string) => {
    setTransferActiveBeneficiary(ben)
    handleBeneficiaryClose()
    checkAccountNumber()
  }

  // ✅ filter beneficiaries based on search
  const filteredBeneficiaries = useMemo(() => {
    const beneficiaries = data?.users?.[0]?.beneficiarySame ?? []

    if (!search?.trim()) return beneficiaries

    return beneficiaries.filter((b: any) =>
      b?.name?.toLowerCase().includes(search.toLowerCase()) ||
      b?.accountNumber?.includes(search)
    )
  }, [search, data])


  return (
    <div id="sidebar-wrapper-beneficiaries-popup" className="sidebar-wrapper-receive-funds">
      <div className="sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable">
        <aside className="sidebar-receive-funds-beneficiaries">
          <div className="funds-beneficiaries-header">
            <h6 className="funds-ben-header-h6">Beneficiaries</h6>
            <button type="button" className="btn-beneficiaries-funds close" onClick={handleBeneficiaryClose}>×</button>
          </div>

          <div className="funds-beneficiaries-body">
            <div style={{ margin: '1rem 0' }}>
              <div>
                {/* ✅ enabled input with search functionality */}
                <input
                  type="text"
                  name="funds-beneficiaries-search"
                  id="funds-beneficiaries-search"
                  className="funds-beneficiaries-search"
                  placeholder="Search beneficiary..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>

              <div style={{ marginBottom: '3rem', height: '230px' }}>
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                  <Scrollbars
                    style={{ transform: 'translateZ(-100px)', height: '230px' }}
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                  >
                    <div id="bill-select-telecom-type-options" style={{ padding: '1rem 0', width: '100%' }}>
                      {filteredBeneficiaries.length > 0 ? (
                        filteredBeneficiaries.map((item: any) => (
                          <div
                            key={item.id}
                            typeof="button"
                            className="bills-dropdown-button-xxx"
                            onClick={() => selectBeneficiaryHandle(item.name)}
                            style={{ width: '100%', display: 'flex' }}
                          >
                            <div>
                              <div className="mint-row">
                                <div className="block-circle" style={{ marginRight: '0.5rem' }}>
                                  {item.initial}
                                </div>
                                <div className="taylor">
                                  <h6 className="mb-0">{item.name}</h6>
                                  <p className="mb-0">{item.accountNumber}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <h6 className="funds-beneficiaries-h6">No Beneficiary Found</h6>
                      )}
                    </div>
                  </Scrollbars>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
}

export default BeneficiariesPopup
